import React from "react";
import { Card, CardContent, Typography, TextField } from "@mui/material";

export default function ChapterViewer({ text, onTextChange }) {
  return (
    <Card sx={{ mt: 3, borderRadius: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Chapter Text
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={5}
          variant="outlined"
          value={text}
          onChange={(e) => onTextChange(e.target.value)}
          placeholder="Enter chapter text here..."
          sx={{ mt: 1 }}
        />
      </CardContent>
    </Card>
  );
}